export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_COUNTRY = 'SET_USER_COUNTRY'
export const SET_INVOICE_DATA = 'SET_INVOICE_DATA'
export const SET_CONSENTS = 'SET_CONSENTS'
export const SET_CALCULATIONS = 'SET_CALCULATIONS'
export const SET_CART_SESSION = 'SET_CART_SESSION'
export const SET_CLIMATE_TAX = 'SET_CLIMATE_TAX'
export const SET_CASHBACK_BALANCE = 'SET_CASHBACK_BALANCE'
export const SET_LOCALE = 'SET_LOCALE'
export const SET_LOGIN_DATA = 'SET_LOGIN_DATA'
export const LOG_IN_USER = 'LOG_IN_USER'
export const VALIDATE_ORDER = 'VALIDATE_ORDER'
export const SET_INVOICE_NEEDED = 'SET_INVOICE_NEEDED'
export const SET_PRIVILEGE_PASS_SELECTED = 'SET_PRIVILEGE_PASS_SELECTED'

export function setCartSession(session) {
    return {
        type: SET_CART_SESSION,
        session
    }
}

export function setClimateTax(climate_tax) {
    return {
        type: SET_CLIMATE_TAX,
        climate_tax
    }
}

export function setCashbackBalance(cashbackBalance) {
    return {
        type: SET_CASHBACK_BALANCE,
        cashbackBalance
    }
}

export function setUserData(args) {
    return {
        type: SET_USER_DATA,
        args
    }
}

export function setUserCountry(country) {
    return {
        type: SET_USER_COUNTRY,
        country
    }
}

export function setInvoiceData(key, value, isRequired) {
    return {
        type: SET_INVOICE_DATA,
        key,
        value,
        isRequired
    }
}

export function setConsent(name) {
    // console.log(name)
    return {
        type: SET_CONSENTS,
        name
    }
}

export function setCalculations(calculations) {
    return {
        type: SET_CALCULATIONS,
        calculations
    }
}

export function setCartId(id) {
    return {
        type: SET_CART_ID,
        id
    }
}

export function setLoginData(key, value, isRequired, isValid) {
    return {
        type: SET_LOGIN_DATA,
        key, value, isRequired, isValid
    }
}

export function setUser(user) {
    return {
        type: LOG_IN_USER,
        user
    }
}

export function onChangeForm(form, name, value) {

    let type = '';
    if (form === 'register') {
        type = 'CHANGE_REGISTER_FORM';
    }
    return {
        type: type,
        name: name,
        value: value
    }
}

export function validateOrder() {
    return {
        type: VALIDATE_ORDER
    }
}

export function setLocale(locale) {
    return {
        type: SET_LOCALE,
        locale
    }
}

export function setInvoiceNeeded() {
    return {
        type: SET_INVOICE_NEEDED,
    }
}

export function setHasPrivilegePass(hasPrivilegePass) {
    return {
        type: SET_PRIVILEGE_PASS_SELECTED,
        hasPrivilegePass
    }
}
